module.exports = require('./helpers/bundle-url').getBundleURL('17nMI') + "blog-1.5db7d4fd.jpeg" + "?" + Date.now();